import ApplicationAdapter from './application';

export default class PracticeWebsite extends ApplicationAdapter {
  // main app handles persistence, but we call save to clean the record
  updateRecord() {}
}
